
import { BaseModuleMobileApi } from "../../base/BaseModuleMobileApi";

export const addAuthToHeader = async (findifyDataContext: any, adminAuthData: any) => {
  if (adminAuthData.access_token) {
    return {  Authorization: 'Bearer ' + adminAuthData.access_token, ...({ workspaceId: findifyDataContext.workspace.workspace_id }) }
  } else {
    return {};
  }
}


export class MobileBOTicketsApi extends BaseModuleMobileApi {
  basePath = 'tickets';


  async validate(findifyDataContext: any, adminAuthData: any, eventId: string, data: any, configOptions?: any) {
    const response = await this.axiosInstance!.post(`${this.basePath}/${eventId}/validate`, data, { headers: await addAuthToHeader(findifyDataContext, adminAuthData), ...configOptions })
    return response?.data;
  };

};
